export default "__VITE_ASSET__7fe71593__"